import styled from 'styled-components';
import { CaptionBoldL, CaptionRegularL, CaptionRegularM } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';
import CloseIcon from '@/assets/icons/closeMark.svg?react';
import OpenIcon from '@/assets/icons/openAllAccordion.svg?react';

export const PrmSlideCont = styled.div`
  position: relative;
  min-height: 32.5rem;
  display: flex;
  justify-content: space-between;

  ${({ theme }: IThemeProvider) => `
    padding: ${theme.layout.spacing.decy} ${theme.layout.spacing.giga};
  `};
`;

export const LeftSlideSideCont = styled.div`
  position: relative;
  display: flex;
  width: 50%;
  flex-direction: column;

  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.decy} 0 0;
  `};
`;

export const DonutCont = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.deka} 0;
  `};
`;

export const DonutTitle = styled(CaptionRegularL)`
  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.centy};
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const RightSlideSideCont = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;

  ${({ theme }: IThemeProvider) => `
    margin: 0 0 0 ${theme.layout.spacing.decy};
  `};
`;

export const SideTitle = styled(CaptionBoldL)`
  text-transform: uppercase;
  letter-spacing: 0.08em;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
    margin: 0 0 ${theme.layout.spacing.mikro} 0;
  `}
`;

export const SideDescription = styled(CaptionRegularL)`
  width: 100%;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const CategoryDesc = styled(CaptionRegularM)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
    margin: ${theme.layout.spacing.decy} 0 0 0;
  `}
`;

export const OpenAll = styled(OpenIcon)`
  width: 7px;
  transform: rotate(45deg);
`;

export const Close = styled(CloseIcon)`
  width: 16px;
  height: 16px;
`;
